import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import Icon from "../../../../../../../../components/icon";
import Tag from "../../../../../../../../components/tag";
import './index.css';

function ContactLabels (props) {

    const {findContactDetails} = props;

    const [leftArrow, setLeftArrow] = useState(false);
    const [rightArrow, setRightArrow] = useState(false);
    const [translateSlide, setTranslateSlide] = useState(0);
    const step = 200;

    useEffect(() => {

        let $tags = document.querySelector('.new-contact-details-popup .tags');
        let $slide = document.querySelector('.new-contact-details-popup .tags .slide');

        if(translateSlide * -1 < $slide.getBoundingClientRect().width - $tags.getBoundingClientRect().width){
            setRightArrow(true);
        } else {
            setRightArrow(false);
        }

        if(translateSlide < 0){
            setLeftArrow(true);
        } else {
            setLeftArrow(false);
        }

    }, [setLeftArrow, setRightArrow, translateSlide]);

    const handleLeftArrowClick = () => {
        if(translateSlide + step <= 0){
            setTranslateSlide(translateSlide + step);
        } else {
            setTranslateSlide(0);
        }
    };

    const handleRightArrowClick = () => {

        let $tags = document.querySelector('.new-contact-details-popup .tags');
        let $slide = document.querySelector('.new-contact-details-popup .tags .slide');

        if(translateSlide * -1 <= $slide.getBoundingClientRect().width - $tags.getBoundingClientRect().width){
            if(translateSlide * -1 + step > $slide.getBoundingClientRect().width - $tags.getBoundingClientRect().width){
                setTranslateSlide((($slide.getBoundingClientRect().width - $tags.getBoundingClientRect().width) * -1) - 16);
            } else {
                setTranslateSlide(translateSlide - step);
            }
        }

    };

    if (findContactDetails){

        return (
            <div className="tags text-nowrap overflow-hidden position-relative mr-2 w-50">
                {
                    leftArrow && <Icon className="tags__left-arrow" name="chevron-left" onClick={handleLeftArrowClick}/>
                }
                <div className="slide" style={{left: translateSlide}}>
                    {
                        findContactDetails.labels.length > 0
                        ?
                            findContactDetails.labels.map( (label) => (
                                <Tag key={label.id} className="mr-2">{label.name}</Tag>
                            ))
                        :
                            ''
                    }
                </div>
                {
                    rightArrow && <Icon className="tags__right-arrow" name="chevron-right" onClick={handleRightArrowClick}/>
                }
            </div>
        )
    } else {
        return (
            <div>
                <Icon animated={'pulse'} name="spinner"/>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails
    }
}

export default connect(mapStateToProps)(ContactLabels);
